import { QuickAdditTabOptionInterface } from '../interfaces/tab-option.interface';
import { UUID } from 'angular2-uuid';

export class QuickAdditTabManager {

    protected tabs = [];

    public constructor() {

    }

    public all() {
        return this.tabs;
    }

    public add(label: string, name: string, options: QuickAdditTabOptionInterface = {}) {

        if (this.tabs.filter(tab => tab.name === name).length > 0) {
            throw new Error('Cannot add tab. Tab with same name exists already');
        }

        this.tabs.push({label, name, options, id: UUID.UUID()});
    }

    public remove(name: string) {

        this.tabs = this.tabs.filter(tab => tab.name !== name);

    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/quick-addit/classes/tab-manager.class.ts